module.exports = __webpack_public_path__ + "static/media/edh.8784b735.svg";